const baseUrl = 'https://toingdev1.wpengine.com/';
const adminAjaxUrl = 'https://toingdev1.wpengine.com/wp-admin/admin-ajax.php';

const api ={
	getGloopOptions : (id = 0) =>{
		return doAdminAjaxRequest({
			action : 'get_object_data',
			object_id : id
		});
	},
	getGloopData : (id = 0, user_id = 0) =>{
		return doAdminAjaxRequest({
			action : 'get_gloop_data',
			object_id : id,
			user_id : user_id
		});
	},
	saveGloop : (id = 0, data,log = '') =>{
		return doAdminAjaxRequest({
			action : 'save_gloop_data',
			id : id,
			data : JSON.stringify(data),
			log : log
		});
	},
	getUserGloops : (user_id) =>{
		return doAdminAjaxRequest({
			action : 'get_user_gloops',
			user_id : user_id
		});
	},
	newGloop : (data) =>{
		return doAdminAjaxRequest({
			action : 'new_gloop',
			data : data
		});
	},
	newAnonimGloop : (data,log) =>{
		return doAdminAjaxRequest({
			action : 'save_anonim_gloop_data',
			data : data,
			log : log
		});
	},
	share : (id, gloop, to) => {
		return doAdminAjaxRequest({
			action : 'share_gloop',
			id : id,
			gloop : gloop,
			to : to
		});
	},
	sendEmail : (email, url, original_gloop, subject, name, digital_id, imgKadr, jsonGloop, facebook, instagram, emailUrl)=>{
		return doAdminAjaxRequest( {
			action: 'sendEmail',
			text: email,
			url,
			original_gloop,
			subject,
			name,
			digital_id,
			imgKadr,
			jsonGloop,
			facebook,
			instagram,
			emailUrl
		});
	},
	savedFiles : (id, activeGloop, className)=>{
		return doAdminAjaxRequest( {
			id,
			activeGloop,
			className
		});
	}
}

const ObjectToFormData = (data = {}) => {
	const _FormData = new FormData()
	for(let key in data){
		_FormData.append(key,data[key]);
	}
	return _FormData;
}

const doAdminAjaxRequest = ( data = {}) =>{
	return doRequest(adminAjaxUrl,data);
}

const doRequest = (url = '', data = {}) => {
	return fetch(url, {
		method: 'POST',
		body: ObjectToFormData(data)
	}).then(response => response.json()).catch((error)=>{
		//TODO: log error
		console.log(error);
	})
}



export function CollectionToObject(arr , key = 'id') {
	let temp = {};
	for(let i=0; i < arr.length; i++){
		temp[arr[i][key]] = arr[i];
	}
	return temp;
}

export default api;
